import { Model } from '@vuex-orm/core'

export default class UserTeam extends Model {
    
    static entity = 'user_team'
  
    static primaryKey = ['user_id', 'team_id']
  
    static fields () {
        return {
            user_id: this.attr(null),
            team_id: this.attr(null)
        }
    }
}